import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod } from "../core/base-api/methods-maker";
export var PlaylistsApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(PlaylistsApi, _BaseApi);

  var _super = _createSuper(PlaylistsApi);

  function PlaylistsApi() {
    _classCallCheck(this, PlaylistsApi);

    return _super.apply(this, arguments);
  }

  return PlaylistsApi;
}(BaseApi);
/**
 * get playlist info
 */

PlaylistsApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Playlists.Paths.ShowPlaylist,
  needAuth: true
});
/**
 * get index of video in playlist
 */

PlaylistsApi.prototype.listVideos = makeMethod({
  method: 'get',
  path: Request.Playlists.Paths.ListPlaylistVideos,
  needAuth: true
});